import {
  AgreementScope, Agreement, AgreementStatusTypes,
  AgreementItemTypes, AgreementItemPropertyTypes
} from 'models'

export const newScope = {
  name: 'New Scope',
  filters: [
    // {
    //   id: 1,
    //   type: 'Projects',
    //   budget: null,
    //   values: null,
    //   projects: [
    //     {
    //       id: 48,
    //       name: 'Asos checkered shirt red',
    //       info: null,
    //       tags: 'Asos Checkered Shirt Red',
    //       status: 'NEW',
    //       createdDate: 1567421364000,
    //       images: null,
    //       mainImage: null,
    //       relatedMedia: null,
    //       loadContents: false,
    //       externalId: '5c07e17d9795340031139e92',
    //       parentId: null,
    //       parentExternalId: null,
    //       children: null,
    //       directors: null,
    //       producers: null,
    //       actors: null,
    //       guestActors: null,
    //       brands: null,
    //       products: null,
    //       loadHierarchy: false,
    //       type: 'Clip',
    //       year: null,
    //       genres: [],
    //       videoUrl: '/p/m/5c07e17d9795340031139e92.mp4',
    //       duration: 11.36
    //     }
    //   ],
    //   brands: [],
    //   products: []
    // },
    // {
    //   id: 2,
    //   type: 'Brands',
    //   budget: null,
    //   values: null,
    //   projects: [],
    //   brands: [],
    //   products: []
    // },
    // {
    //   id: 3,
    //   type: 'Products',
    //   budget: null,
    //   values: null,
    //   projects: [],
    //   brands: [],
    //   products: []
    // },
    // {
    //   id: 4,
    //   type: 'Time Line Tag',
    //   budget: null,
    //   values: null,
    //   projects: [],
    //   brands: [],
    //   products: []
    // },
    // {
    //   id: 6,
    //   type: 'Interactive Area Tag',
    //   budget: null,
    //   values: null,
    //   projects: null,
    //   brands: null,
    //   products: null
    // }
  ]
} as AgreementScope

export const newAgreement = {
  name: '',
  budget: null,
  period: null,
  status: AgreementStatusTypes.ACTIVE,
  effectOnElements: false,
  items: [
    {
      type: AgreementItemTypes.BLOB_SETTINGS,
      properties: {
        [AgreementItemPropertyTypes.BLOB_TRIGGERED]: 0.0,
        [AgreementItemPropertyTypes.PRICE_PER_TIME_ON_SCREEN_ATTACHED]: 0.0,
        [AgreementItemPropertyTypes.MAX_ATTACH_TIME_SECONDS]: 0.0,
        [AgreementItemPropertyTypes.PRICE_PER_TIME_ON_SCREEN_DETACHED]: 0.0,
        [AgreementItemPropertyTypes.MINIMUM_TIME_IN_STACK]: 0.0,
        [AgreementItemPropertyTypes.MAXIMUM_TIME_IN_STACK]: 0.0
      }
    },
    {
      type: AgreementItemTypes.PRODUCT,
      properties: {
        [AgreementItemPropertyTypes.PRODUCT_PAGE_OPENED_FROM_BLOB]: 0.0,
        [AgreementItemPropertyTypes.PRODUCT_ADDED_TO_CART]: 0.0
      }
    },
    {
      type: AgreementItemTypes.VIDEO_COMMERCIAL,
      properties: {
        [AgreementItemPropertyTypes.PRICE_PER_VIDEO_PLAYBACK]: 0.0
      }
    },
    {
      type: AgreementItemTypes.POSTER,
      properties: {
        [AgreementItemPropertyTypes.PRICE_PER_CLICK]: 0.0,
        [AgreementItemPropertyTypes.PRICE_PER_TIME_ON_SCREEN]: 0.0
      }
    },
    {
      type: AgreementItemTypes.PRODUCT_PURCHASE,
      properties: {
        [AgreementItemPropertyTypes.PURCHASE_FEE]: 0.0
      }
    }
  ],
  scopes: []
} as Agreement
